<template>
    <div class="info"> 
        <div class="content">
            <van-field
                v-model="dataList.customerName"
                readonly
                label-width= 90
                label="姓名"
                size="medium"
                class="inputVant"
            />
            <van-field
                v-model="phone"
                label-width= 90
                size="medium"
                class="inputVant"
                center
                clearable
                readonly
                label="手机号"
            >
            </van-field>
            <van-field
                v-model="dataList.address"
                label-width= 90
                size="medium"
                class="inputVant"
                center
                clearable
                readonly
                label="收货地址"
            >
            </van-field>
            <div class="boreder"></div>
        </div>
    </div>
</template>
<script>
import { Field } from 'vant';
import { getCustomerInfo } from '@/api/index';
export default {
    components:{
        [Field.name] : Field,
    },
    data(){
        return {
            phone: '',
            verification:'',
            dataList:{
                customerName:'',
                address: ''
            },
            phone: ''
        }
    },
    created(){
        this.phone = this.$loca.getItem('phone');
        this.getData();
    },
    methods:{
        getData(){
            let data = this.$loca.getItem('phone');
            getCustomerInfo({phone: data}).then(res=>{
                this.dataList = res.data;
            }).catch(error=>{

            })
        }
    }
}
</script>
<style lang="scss" scoped>
.info{
    width: 100vw;
    height: 100%;

}
.content{
    margin: 0 20px;
}
.inputVant{
    line-height: 71px;
    align-items:center;
    position: relative;
}
</style>

